import React, { memo, forwardRef } from "react";
const SvgCombinationswithrepetitions = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.56 23.88c-1.107 0-2.127-.18-3.06-.54a7.256 7.256 0 01-2.38-1.54 7.145 7.145 0 01-1.56-2.36C9.187 18.52 9 17.507 9 16.4c0-1.133.193-2.153.58-3.06.4-.92.94-1.7 1.62-2.34a7.303 7.303 0 012.44-1.48c.933-.347 1.947-.52 3.04-.52.813 0 1.587.12 2.32.36.747.227 1.353.54 1.82.94.24.213.393.407.46.58.067.16.1.313.1.46 0 .32-.113.593-.34.82-.213.227-.493.34-.84.34a1.23 1.23 0 01-.42-.08 2.905 2.905 0 01-.54-.32c-.28-.24-.647-.447-1.1-.62a3.952 3.952 0 00-1.46-.26c-.733 0-1.4.133-2 .4-.6.267-1.12.633-1.56 1.1a5.112 5.112 0 00-1 1.64 5.954 5.954 0 00-.34 2.04c0 .773.113 1.48.34 2.12a4.98 4.98 0 00.96 1.66c.427.453.933.807 1.52 1.06s1.247.38 1.98.38c.56 0 1.08-.087 1.56-.26.493-.173.96-.453 1.4-.84.213-.187.387-.3.52-.34a1.23 1.23 0 01.42-.08c.307 0 .567.1.78.3.227.187.34.453.34.8 0 .16-.04.333-.12.52-.08.187-.213.373-.4.56-.453.44-1.067.82-1.84 1.14-.773.307-1.667.46-2.68.46z"
      />
      <rect width={6} height={8} x={23} y={19} fill="#DBDBDB" rx={1} />
      <rect width={6} height={8} x={3} y={19} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M5.054 6.552h.862c.15 0 .302-.01.452-.033.15-.022.285-.064.402-.126a.797.797 0 00.301-.26.783.783 0 00.117-.443.656.656 0 00-.108-.393.794.794 0 00-.277-.251 1.158 1.158 0 00-.385-.126 2.594 2.594 0 00-.41-.033h-.954v1.665zm.77.862h-.77v1.992c0 .128-.02.231-.058.31a.563.563 0 01-.142.175.34.34 0 01-.168.084.618.618 0 01-.159.025.618.618 0 01-.159-.025.393.393 0 01-.176-.084.634.634 0 01-.133-.176.696.696 0 01-.059-.31V4.629C4 4.209 4.21 4 4.628 4h1.43c.28 0 .55.03.812.092.263.056.494.15.695.285.206.133.37.31.494.527.122.217.184.482.184.795 0 .43-.123.78-.369 1.054-.24.268-.569.45-.987.544L8.134 9.13a.668.668 0 01.092.192.494.494 0 01-.117.536.498.498 0 01-.368.142.557.557 0 01-.235-.059.62.62 0 01-.226-.226l-1.456-2.3z"
      />
    </svg>
  );
});
SvgCombinationswithrepetitions.displayName = "SvgCombinationswithrepetitions";
const MemoForwardRef = memo(SvgCombinationswithrepetitions);
export default MemoForwardRef;
